
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton } from '@/components';
import { useMixins } from '@/modules/promotion/code/model/detail';
import { formatDate, renderOption } from '@/common/utils/helpers';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.CODE.DETAIL,
    components: { AppCard, AppButton },
    setup() {
        const { model, Options, fetch, actions } = useMixins();

        onMounted(async () => {
            await fetch();
        });

        return { model, Options, formatDate, renderOption, actions };
    }
});
